export function encodeURIComponents(...components) {
    return components.map(encodeURIComponent).join("/");
}
export function mapQueryString(query) {
    if (query[0] === "?") {
        query = query.substr(1);
    }
    return query.split("&").reduce((result, keyValueString) => {
        const split = keyValueString.split("=");
        if (split.length === 2) {
            result.set(split[0], decodeURIComponent(split[1]));
        }
        return result;
    }, new Map());
}
export function unmapQueryString(query) {
    return Array.from(query)
        .map((kv) => `${kv[0]}=${encodeURIComponent(kv[1])}`)
        .join("&");
}
